import { pt } from './pt';
import { en } from './en';
import { fr } from './fr';
import { es } from './es';

export const translations = { pt, en, fr, es };
